import type { SocialNetworksBlockProps } from "./types";
import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { SocialNetworksEmailRenderer } from "./email";
import { useMemo } from "react";

export function SocialNetworksWeb({ ...props }: SocialNetworksBlockProps) {
  const { shop } = props;

  const socialNetworks = useMemo(() => {
    return shop.externalLinks
      ? Object.entries(shop.externalLinks).filter(
          ([_, link]) => link?.type === "SOCIAL_NETWORK" && link?.url,
        )
      : [];
  }, [shop.externalLinks]);

  if (socialNetworks.length === 0) {
    return null;
  }

  return (
    <EmailComponentWrapper shop={props.shop}>
      <SocialNetworksEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
